module.exports = __webpack_public_path__ + "img/ben-about-hero.0933b9db.svg";